import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { AdvancedFiltersContainer } from '../../containers/filters/AdvancedFiltersContainer';
import { IFilter } from '../../types/filters';

export const advancedFilters: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: AdvancedFiltersContainer,
};
